import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getApiUrl } from '@shared/utils/app-util';

export interface ExtendSessionResponse {
  access_token?: string;
  csrf_token?: string;
  token_expires?: string; // ISO
  token_type?: string;
  // other fields ignored
}

export interface HelpDocumentResponse {
  file_name?: string;
  signed_url?: string;
  document_title?: string;
}

export interface SearchResult {
  type: 'user' | 'rca' | 'response';
  user_id: number | null;
  rca_id: number | null;
  response_id: number | null;
  title: string;
  subtitle: string;
  description: string;
  status: string | null;
}

export interface GlobalSearchResponse {
  message: string;
  search: string;
  total_results: number;
  results: SearchResult[];
}

@Injectable({ providedIn: 'root' })
export class HeaderService {
  constructor(private readonly http: HttpClient) {}

  extendSession(token: string): Observable<ExtendSessionResponse> {
    const url = getApiUrl('EXTEND_SESSION');
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}`, Accept: 'application/json' });
    return this.http.patch<ExtendSessionResponse>(url, null, { headers });
  }

  getHelpDocument(): Observable<HelpDocumentResponse> {
    const url = getApiUrl('DASHBOARD_HELP_DOCUMENT');
    return this.http.get<HelpDocumentResponse>(url);
  }

  globalSearch(searchQuery: string, limit: number = 5): Observable<GlobalSearchResponse> {
    const url = `${getApiUrl('DASHBOARD_SEARCH')}?search=${encodeURIComponent(searchQuery)}&limit=${limit}`;
    return this.http.get<GlobalSearchResponse>(url);
  }
}
